import React, { useState, useEffect } from 'react'
import { Link, graphql } from "gatsby"
import defaultArticlePic from "../assets/default_articlePic.jpg"
import { defineCustomElements as highlightCodeBlock } from '@deckdeckgo/highlight-code/dist/loader'

import Head from "../components/Head"
import Layout from "../components/Layout"


export default function ArticleTemplate({ data }) {
  const [isValidImg, setIsValidImg] = useState(true)
  const { frontmatter, html } = data.markdownRemark

  const formatDescription = desc => desc.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 150)

  useEffect(() => {
    highlightCodeBlock()
  }, [])

  return (
    <>
      <Head
        title={frontmatter.title}
        description={formatDescription(html)}
        img={frontmatter.img}
        url={`https://maxime-bounaas.netlify.app${frontmatter.path}`}
      />
      <Layout>
        <article className="articlePage">
          <div className="article">
            <Link to="/articles">
              <button className="backBtn">Retour</button>
            </Link>
            <div className="bannerImg">
              <img src={isValidImg ? frontmatter.img || defaultArticlePic : defaultArticlePic} onError={() => setIsValidImg(false)} alt="article banner"/>
            </div>
            <div className="article_content">
              <h2 className="title">{frontmatter.title}</h2>
              <div 
                className="content"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
          </div>
        </article>
      </Layout>
    </>
  )
}

export const articleQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        img
        createdAt
      }
    }
  }
`
